//import thu vien trong react
import { useState,useEffect,useContext } from "react";

//import context
import Context from '../../Store/Context';

//import phần translate
import { useTranslation } from "react-i18next";


import "./AllCoin.css";

import CoinTableCpn from "../../Component/Coin/CoinTableCpn";

function AllCoinPage(){
    const [state,dispatch] = useContext(Context);
    //phần translate
    const { t } = useTranslation("translation");

    return (
        <>
            <div className="PopularArticles_mainDiv__kBBDR">
                <div className="PopularArticles_componentDiv__SzJoL">
                    <div className="PopularArticles_topDiv__gYCfp">
                        <div className="PopularArticles_title__BFUne">
                            <h2>{t("All_cryptocurrencies")}</h2>
                        </div>
                    
                    </div>
                    
                    
                    <CoinTableCpn />
                    

                </div>
            </div>
        </>
    )
}

export default AllCoinPage;